/*==============================================================================
TRESTLE™ W010
SUPPORT & GUIDANCE

Brand        : Diafemme®
Module       : W010
File         : TRESTLE_W010_Support.js
Version      : 1.0

Responsibilities
----------------
• FAQ accordion behaviour
• Consultation CTA readiness
• No backend calls
• No booking logic until consultation launches
==============================================================================*/

"use strict";


const TrestleW010 = (() => {


/*==============================================================================
RUNTIME
==============================================================================*/

let root = null;


/*==============================================================================
INITIALIZE
==============================================================================*/

function initialize() {

    root =
        document.getElementById(
            "trW010"
        );


    if (!root) {

        return;

    }


    if (
        root.dataset.w010Initialized ===
        "true"
    ) {

        return;

    }


    root.dataset.w010Initialized =
        "true";


    bindFaqs();

    bindConsultation();


    console.info(
        "TRESTLE W010 Support Ready"
    );

}


/*==============================================================================
FAQ ACCORDION
==============================================================================*/

function bindFaqs() {

    const questions =
        root.querySelectorAll(
            ".tr-w010-faq-question"
        );


    questions.forEach(

        question => {

            question.addEventListener(

                "click",

                () => {

                    toggleFaq(
                        question
                    );

                }

            );

        }

    );

}


/*==============================================================================
TOGGLE FAQ
==============================================================================*/

function toggleFaq(
    question
) {

    if (!question) {

        return;

    }


    const targetId =
        question.getAttribute(
            "aria-controls"
        );


    if (!targetId) {

        return;

    }


    const answer =
        document.getElementById(
            targetId
        );


    if (!answer) {

        return;

    }


    const isOpen =
        question.getAttribute(
            "aria-expanded"
        ) === "true";


    /*
    Keep only one FAQ open at a time.
    This keeps the closing section compact.
    */

    closeAllFaqs(
        question
    );


    if (isOpen) {

        question.setAttribute(
            "aria-expanded",
            "false"
        );

        answer.hidden =
            true;

        return;

    }


    question.setAttribute(
        "aria-expanded",
        "true"
    );

    answer.hidden =
        false;

}


/*==============================================================================
CLOSE OTHER FAQS
==============================================================================*/

function closeAllFaqs(
    exceptQuestion = null
) {

    const questions =
        root.querySelectorAll(
            ".tr-w010-faq-question"
        );


    questions.forEach(

        question => {

            if (
                question ===
                exceptQuestion
            ) {

                return;

            }


            question.setAttribute(
                "aria-expanded",
                "false"
            );


            const targetId =
                question.getAttribute(
                    "aria-controls"
                );


            if (!targetId) {

                return;

            }


            const answer =
                document.getElementById(
                    targetId
                );


            if (answer) {

                answer.hidden =
                    true;

            }

        }

    );

}


/*==============================================================================
CONSULTATION
==============================================================================*/

function bindConsultation() {

    const button =
        document.getElementById(
            "trW010ConsultButton"
        );


    if (!button) {

        return;

    }


    button.addEventListener(

        "click",

        () => {

            handleConsultation(
                button
            );

        }

    );

}


/*==============================================================================
HANDLE CONSULTATION
*
*Current state:
*COMING SOON
*
*Future activation:
*
*1. Remove disabled from button in Liquid.
*2. Change data-consultation-status="active".
*3. Set booking route below.
*
*No redesign required.
==============================================================================*/

function handleConsultation(
    button
) {

    if (!button) {

        return;

    }


    const status =
        button.dataset
            .consultationStatus ||
        "coming-soon";


    if (
        status !==
        "active"
    ) {

        return;

    }


    /*
    FUTURE BOOKING ROUTE

    Replace this URL when consultation launches.
    */

    const bookingRoute =
        "/pages/meet-our-experts";


    window.location.href =
        bookingRoute;

}


/*==============================================================================
PUBLIC API
==============================================================================*/

return {

    initialize,


    openFaq(id) {

        if (!root) {

            initialize();

        }


        const question =
            root
                ? root.querySelector(
                    `[aria-controls="${id}"]`
                )
                : null;


        if (
            question &&
            question.getAttribute(
                "aria-expanded"
            ) !== "true"
        ) {

            toggleFaq(
                question
            );

        }

    },


    closeFaqs() {

        if (!root) {

            return;

        }


        closeAllFaqs();

    }

};

})();


/*==============================================================================
PUBLIC NAMESPACE
==============================================================================*/

window.TrestleW010 =
    TrestleW010;


/*==============================================================================
BOOT
==============================================================================*/

if (
    document.readyState ===
    "loading"
) {

    document.addEventListener(

        "DOMContentLoaded",

        () => {

            TrestleW010.initialize();

        }

    );

}

else {

    TrestleW010.initialize();

}


/*==============================================================================
TRESTLE™ W010
SUPPORT & GUIDANCE
Version 1.0
COMPLETE
==============================================================================*/